import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IAppleAdsCampaignDetail } from "../../features/Campaigns/interface/appleAds";
import { useAuth } from "../helper/useAuth";
import dayjs from "dayjs";

interface UseAppleAdsCampaignDetailProps {
  campaignId: string | number;
  startDate?: Date;
  endDate?: Date;
  enabled?: boolean;
}

export const useAppleAdsCampaignDetail = ({
  campaignId,
  startDate,
  endDate,
  enabled = true,
}: UseAppleAdsCampaignDetailProps) => {
  const { selectedIntegration } = useAuth();

  return useQuery<IAppleAdsCampaignDetail, Error>({
    queryKey: [
      "apple-ads-campaign-detail",
      campaignId,
      startDate?.toISOString(),
      endDate?.toISOString(),
      selectedIntegration?.value,
    ],
    queryFn: async () => {
      const url = API_CONFIG.path.appleAdsCampaignDetail.replace(
        ":id",
        String(campaignId),
      );
      const queryParams = {
        ...(startDate && { start_date: dayjs(startDate).format("YYYY-MM-DD") }),
        ...(endDate && { end_date: dayjs(endDate).format("YYYY-MM-DD") }),
        tracking_id: selectedIntegration?.value as string,
      };

      return httpService.get<IAppleAdsCampaignDetail>(url, queryParams);
    },
    enabled: !!campaignId && !!selectedIntegration?.value && enabled,
  });
};
